import columns from "./columns";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "supplierContracts",
    pageTitle: "Supplier Contracts",
    columns,
    formFields,
    previewFields,
    tableOptions: { hideSearch: true },
    formOptions: {},
};
